/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_Event_Group_End_TimeInputs */



/**
* | output |
* | --- |
* | "End Time" |
*
* @param {Markers_Create_Event_Group_End_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_event_group_end_time = /** @type {((inputs?: Markers_Create_Event_Group_End_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_Event_Group_End_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heure de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ora di fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конец времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin de los tiempos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hora final")
	return /** @type {LocalizedString} */ ("End Time")
});